import { getTutorBookingFilterCount } from './tutorBookingFilters';
import type {
  TutorBookingFilter,
  TutorBookingNeedsTutorActionCountResponse,
  TutorBookingNeedsUserActionCountResponse,
  TutorBookingSummaryCountsResponse,
} from '../models/Tutor';

type NeedsActionCountResponse =
  | TutorBookingNeedsTutorActionCountResponse
  | TutorBookingNeedsUserActionCountResponse;

/** Prefer dedicated needs-action count; never invent from list rows. */
export function getNeedsActionCountFromResponse(
  response: NeedsActionCountResponse | null | undefined,
): number {
  if (!response) return 0;
  const raw =
    'needsUserActionCount' in response
      ? response.needsUserActionCount
      : response.needsTutorActionCount;
  return Math.max(0, raw ?? 0);
}

export type TutorBookingNeedsActionSummaryFilter =
  | Extract<TutorBookingFilter, 'needs_tutor_action' | 'needs_user_action'>;

/**
 * Summary tab counts for the split queues:
 * - needs_tutor_action → pending tutor/host confirmation only
 * - needs_user_action → active change proposal awaiting user reply only
 */
export function getNeedsActionCountFromSummary(
  summary: TutorBookingSummaryCountsResponse | null | undefined,
  filter: TutorBookingNeedsActionSummaryFilter,
): number {
  return getTutorBookingFilterCount(summary, filter);
}
